'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  pointer-events: none;\n'], ['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  pointer-events: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: 90vw;\n  border: 1px solid gray;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n\n  img {\n    max-width: 80%;\n    max-height: 50%;\n  }\n'], ['\n  max-width: 90vw;\n  border: 1px solid gray;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n\n  img {\n    max-width: 80%;\n    max-height: 50%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _stage = require('../stage/stage');

var _stage2 = _interopRequireDefault(_stage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Panel = _styledComponents2.default.div(_templateObject2);

/** @class Curtain
  * Displays a closed screen after the show has closed
  * @prop {Date} closes - the date the show closes.  Not required for samples.
  * @prop {Boolean} isSample (default false) - if the show is a sample expo.
  * @prop {Object} stage - the entry stage to use as a background
  * @prop {URLString} logo (optional) - the logo image location.
  */

var Curtain = function (_Component) {
  _inherits(Curtain, _Component);

  function Curtain(props) {
    _classCallCheck(this, Curtain);

    var _this = _possibleConstructorReturn(this, (Curtain.__proto__ || Object.getPrototypeOf(Curtain)).call(this, props));

    _this.state = { open: _this.props.isSample || _this.props.closes - Date.now() > 0 };
    return _this;
  }
  /** @method componentWillMount
    * Checks for special preview access.
    */


  _createClass(Curtain, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /*
      if(window.vexpo && window.vexpo.firebase && window.vexpo.firebase.auth().currentUser) {
        const uid = window.vexpo.firebase.auth().currentUser.uid;
        window.vexpo.firebase.database().ref(`specialPreviewAccess/${uid}`).once('value', snapshot => {
          if(snapshot.val()) this.setState({open: true});
        });
      }*/
    }
  }, {
    key: 'render',
    value: function render() {
      if (true || this.state.open) return this.props.children;else return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_stage2.default, this.props.stage),
        _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            Panel,
            null,
            _react2.default.createElement('img', { src: this.props.logo, alt: 'logo' }),
            _react2.default.createElement(
              'h2',
              null,
              'The Show Has Closed'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Thanks for visiting.  Come back next year!'
            )
          )
        )
      );
    }
  }]);

  return Curtain;
}(_react.Component);

exports.default = Curtain;


Curtain.defaultProps = {
  isSample: false
};

Curtain.propTypes = {
  isSample: _propTypes2.default.bool.isRequired,
  closes: _propTypes2.default.number.isRequired,
  stage: _propTypes2.default.object.isRequired,
  logo: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/curtain/curtain.js
// module id = 1352
// module chunks = 0